module.exports = __webpack_public_path__ + "static/img/hb_16-min.dfa4b59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_16-min.png
// module id = /2N7
// module chunks = 1